import React, { Component } from 'react';

class Footer extends Component {
  render () {
    return (
      <footer className="footer">
        <div className="container-fluid">
          <span className="text-muted text-sm-left">  2082 Business Center Dr. Suite 280, Irvine CA 92612 ​949-236-4342</span>
          <div className="d-sm-flex justify-content-center justify-content-sm-between">
            <span className="text-muted text-sm-left"> Copyright © 2020 SignMeIn Center - All Rights Reserved.</span>
            {/*<span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Developed by <i className="mdi mdi-spa text-danger"></i></span>*/}
          </div>
        </div>
      </footer>
    );
  }
}

export default Footer;
